import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsArray, IsNotEmpty, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class PatchWebMerchantAppHomeScreenSliderWidgetSlideDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ groups: [WebMerchantExposeGroup.READ, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    MaxLength(500, { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.prototype, "image", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(100, { always: true }),
    IsUrl({ require_host: true }, { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.prototype, "externalUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(100, { always: true }),
    IsUrl({ require_host: true }, { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.prototype, "internalUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    IsUrl({ require_host: true, require_protocol: true, protocols: ['http', 'https'] }, { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.prototype, "externalLink", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    __metadata("design:type", String)
], PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.prototype, "internalLink", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    MaxLength(50, { always: true, each: true }),
    __metadata("design:type", Array)
], PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.prototype, "tags", void 0);
//# sourceMappingURL=PatchWebMerchantAppHomeScreenSliderWidgetSlideDto.js.map